/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { WidgetContext } from './widget-context-base';
import { iamLogin } from '../main';
import { WidgetElements } from '../elements/widget-elements-base';
import { iam } from '../iam';

export class EnrollManualTotpWidgetContext extends WidgetContext {
  constructor(elements: WidgetElements) {
    super(elements);
  }

  public override initialize() {
    if (iam.settings.debug) console.log('initializing otp text code widget');
    document.getElementById('dont-have-a-mvision').style.display = 'none';
    iamLogin.registerLocalizationCallback(() => {
      iamLogin.localizeElement('sub-header', 'otpAppSetup');
      const instructions = document.querySelector('.secret-key-instructions');
      let instructionText = instructions.querySelector('p.textCodeInstructions');
      if (!instructionText) {
        instructionText = document.createElement('p');
        instructionText.className = 'textCodeInstructions';
        if (instructions.children.length > 0) {
          instructions.insertBefore(instructionText, instructions.children[0]);
        } else {
          // there should always be children, but just in case there aren't...
          instructions.appendChild(instructionText);
        }
      }
      iamLogin.localizeElement(instructionText, 'otpAppTextCode');
    }, true, true);
    // okta's "show qr code?" link appears under the "next" button but we want it under the text code to match the
    // "can't scan?" link under the qr code. we can't just move their anchor element because it breaks, and sends
    // the user back to the password screen. instead, we'll simulate a click on their link when our link is clicked.
    const oktaShowQrLink = document.querySelector<HTMLAnchorElement>('a[data-se=goto-link]');
    oktaShowQrLink.style.display = 'none';
    const ourShowQrLink = document.createElement('a');
    ourShowQrLink.href = 'javascript:;'; // better than setting it to '#' because widget watches hashchange events and it messes up the state of the widget
    ourShowQrLink.className = 'link showQR';
    ourShowQrLink.addEventListener('click', () => oktaShowQrLink.click());
    document.querySelector('.secret-key-instructions').appendChild(ourShowQrLink);
    iamLogin.registerLocalizationCallback(() => {
      iamLogin.localizeElement(ourShowQrLink, 'otpAppShowQr');
    }, true, true);

    iamLogin.page.showCommonFields(['auth-footer']);
    iamLogin.page.initializeCommon();
  }
}
